import {
  initializeApp,
  getApps,
  getApp,
} from "firebase/app";

import {
  getAnalytics,
  isSupported,
} from "firebase/analytics";

import {
  getAuth,
} from "firebase/auth";

import {
  getFirestore,
} from "firebase/firestore";

import {
  getStorage,
} from "firebase/storage";

import {
  getFunctions,
} from "firebase/functions";


/* =========================================================
   FIREBASE CONFIG
========================================================= */

const firebaseConfig = {
  apiKey: "AIzaSyC-zM1ScaammW_WDPF4_rUmaholScuqvko",

  authDomain:
    "matrixbet-f146d.firebaseapp.com",

  projectId:
    "matrixbet-f146d",

  storageBucket:
    "matrixbet-f146d.firebasestorage.app",

  messagingSenderId:
    "189981344196",

  appId:
    "1:189981344196:web:82acc3c567131523482491",

  measurementId:
    "G-H18BHYDKP4",
};


/* =========================================================
   INITIALIZE FIREBASE ONCE
========================================================= */

const app =
  !getApps().length
    ? initializeApp(firebaseConfig)
    : getApp();


/* =========================================================
   AUTH
========================================================= */

export const auth =
  getAuth(app);


/* =========================================================
   FIRESTORE
========================================================= */

export const db =
  getFirestore(app);


/* =========================================================
   STORAGE
========================================================= */

export const storage =
  getStorage(app);


/* =========================================================
   CLOUD FUNCTIONS
========================================================= */

export const functions =
  getFunctions(
    app,
    "us-central1"
  );


/* =========================================================
   ANALYTICS
========================================================= */

export let analytics = null;


/*
 * Analytics inaweza kutokufanya kazi kwenye baadhi
 * ya mazingira, kwa hiyo usiache app ivunjike.
 */

if (
  typeof window !== "undefined"
) {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics =
          getAnalytics(app);
      }
    })
    .catch((error) => {
      console.warn(
        "Firebase Analytics unavailable:",
        error
      );
    });
}


/* =========================================================
   EXPORT APP
========================================================= */

export default app;